"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaForm = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _some = _interopRequireDefault(require("lodash/some"));

var _theme = require("../../theme");

var _basis = require("basis");

var _ = require("./..");

var s = _interopRequireWildcard(require("./MfaForm.styles"));

var _getValidation = require("../../utils/getValidation");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-ignore
var getSetContent = function getSetContent(set) {
  var setElements = /*#__PURE__*/_react.default.createElement(FieldList, {
    fields: set.subElements
  });

  var containPassword = (0, _some.default)(set.subElements, function (field) {
    return field.type === 'password';
  });

  if (containPassword) {
    return /*#__PURE__*/_react.default.createElement(s.RCCFields, {
      "data-testid": "rcc-fields-container"
    }, setElements);
  }

  switch (set.id) {
    case 'RCCFields':
      return /*#__PURE__*/_react.default.createElement(s.RCCFields, {
        "data-testid": "rcc-fields-container"
      }, setElements);

    default:
      return setElements;
  }
};

var validation = function validation(field) {
  var _ref = field,
      htmlAttrs = _ref.htmlAttrs,
      optional = _ref.optional;

  if (!htmlAttrs) {
    return (0, _getValidation.getValidation)({
      optional: optional
    });
  }

  var minlength = htmlAttrs.minlength,
      maxlength = htmlAttrs.maxlength;
  return (0, _getValidation.getValidation)({
    minLength: minlength,
    maxLength: maxlength,
    optional: optional
  });
}; // Handle differing options response shapes from Proviso api


var getOptions = function getOptions(options) {
  if (!options || (0, _typeof2.default)(options) !== 'object') {
    return [];
  }

  if (Array.isArray(options)) {
    return options.map(function (option) {
      var label = option.label,
          value = option.value,
          id = option.id;
      return {
        label: label,
        value: value,
        id: id
      };
    });
  }

  return Object.entries(options).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        value = _ref3[0],
        label = _ref3[1];

    return {
      label: String(label),
      value: value
    };
  });
};

var isDisabled = function isDisabled(input) {
  if (!input.id) {
    return true;
  }

  if (input.hasOwnProperty('active') && !input.active) {
    return true;
  }

  if (input.htmlAttrs && input.htmlAttrs.disabled) {
    return true;
  }

  return false;
};

var FieldList = function FieldList(props) {
  var fields = props.fields;
  var theme = (0, _theme.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fields.map(function (field, index) {
    switch (field.type) {
      case 'header':
        var header = field;
        return /*#__PURE__*/_react.default.createElement(_basis.Text, {
          key: index,
          color: theme.headingColor,
          textStyle: theme.headingSize
        }, header.value);

      case 'instructions':
        var instructions = field;
        return /*#__PURE__*/_react.default.createElement(_basis.Text, {
          key: index
        }, instructions.value);

      case 'image':
        var image = field;
        return /*#__PURE__*/_react.default.createElement("img", {
          key: index,
          width: image.width,
          height: image.height,
          src: image.src,
          alt: image.alt || 'Multi factor authentication'
        });

      case 'input':
      case 'password':
        var input = field;

        if (!input.id) {
          return /*#__PURE__*/_react.default.createElement(s.InputPlaceholder, {
            key: index
          });
        }

        var inputContent = /*#__PURE__*/_react.default.createElement(_basis.Input, {
          key: index,
          id: input.id,
          name: input.id,
          testId: input.id,
          hideLabel: !input.label,
          showLabel: false,
          placeholder: (0, _get.default)(input, 'htmlAttrs.placeholder') || '',
          label: input.label || '',
          type: input.type === 'password' ? 'password' : (0, _get.default)(input, 'htmlAttrs.type') || 'text',
          optional: input.optional,
          disabled: isDisabled(input),
          autoComplete: (0, _get.default)(input, 'htmlAttrs.autocomplete') || 'off',
          maxLength: (0, _get.default)(input, 'htmlAttrs.maxlength') || 999,
          minLength: (0, _get.default)(input, 'htmlAttrs.minlength') || 0,
          validate: validation(input),
          color: theme.inputColor
        });

        var size = (0, _get.default)(input, 'htmlAttrs.size');
        return size ? /*#__PURE__*/_react.default.createElement(s.InputContainer, {
          "data-testid": "InputContainer",
          key: index
        }, inputContent) : inputContent;

      case 'hidden':
        return null;

      case 'options':
        var options = field;
        var fieldProps = {
          key: index,
          id: options.id,
          name: options.id,
          testId: options.id,
          label: options.label || '',
          optional: options.optional,
          options: getOptions(options.options),
          validate: validation(options),
          color: theme.inputColor
        };

        switch (options.hint) {
          case 'radio':
            return /*#__PURE__*/_react.default.createElement(_basis.RadioGroup, (0, _extends2.default)({
              columns: 1
            }, fieldProps));

          case 'select':
          default:
            return /*#__PURE__*/_react.default.createElement(_basis.Select, (0, _extends2.default)({}, fieldProps, {
              placeholder: "Please select"
            }));
        }

      case 'set':
        var set = field;
        return /*#__PURE__*/_react.default.createElement("div", {
          id: set.id,
          key: index
        }, set.label && /*#__PURE__*/_react.default.createElement(_basis.Text, null, set.label), getSetContent(set));

      default:
        return null;
    }
  }));
};

var MfaForm = function MfaForm(props) {
  var initialValues = props.initialValues,
      fields = props.fields,
      loading = props.loading,
      onSubmit = props.onSubmit,
      onGoBack = props.onGoBack;

  var handleSubmit = function handleSubmit(state) {
    !Object.keys(state.errors).length && onSubmit(state.values);
  };

  return /*#__PURE__*/_react.default.createElement(_.Form, {
    initialValues: initialValues,
    onSubmit: loading ? function () {} : handleSubmit
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_.FormLayout, null, /*#__PURE__*/_react.default.createElement(FieldList, {
      fields: fields
    }), /*#__PURE__*/_react.default.createElement(_.FormButtonsLayout, null, /*#__PURE__*/_react.default.createElement(_.SubmitButton, {
      loading: loading
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "mfa.buttonSubmit"
    })), /*#__PURE__*/_react.default.createElement(_basis.Button, {
      variant: "secondary",
      onClick: onGoBack
    }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
      path: "mfa.buttonBack"
    }))));
  });
};

exports.MfaForm = MfaForm;